export default {
    FormatDateTime: function (date) {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Intl.DateTimeFormat('es-ES', options).format(new Date(date));
    },
    FormatDate: function (date) {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return new Intl.DateTimeFormat('es-ES', options).format(new Date(date));
    },
    FormatPriceWithoutDecimals: function (price) {
        return Math.round(price).toLocaleString('es-ES').replace(',', '.');
    },
    FormatPrice: function (price) {
        return price.toFixed(2).toLocaleString('es-ES').replace('.', ',');
    },
    isHTML: function (str) {
        var a = document.createElement('div');
        a.innerHTML = str;

        for (var c = a.childNodes, i = c.length; i--; ) {
            if (c[i].nodeType == 1) return true;
        }

        return false;
    }
};


// import moment from 'moment';
// export default {
//     FormatDateTime: function (date) {
//         return moment(date).format('DD/MM/YYYY HH:mm');
//     },
//     FormatDate: function (date) {
//         return moment(date).format('DD/MM/YYYY');
//     },
//     FormatPriceWithoutDecimals: function (price){
//          return Math.round(price).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
//     },
//     FormatPrice: function (price) {
//         let price_ = price.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(',');
//         if (price_.length === 1) {
//             price_[1] = "00";
//         } else if (price_[1].length === 1) {
//             price_[1] = price_[1] + "0";
//         }
//         return price_.join(',');
//    },
//    isHTML: function (str) {
//      var a = document.createElement('div');
//      a.innerHTML = str;

//      for (var c = a.childNodes, i = c.length; i--; ) {
//        if (c[i].nodeType == 1) return true;
//      }

//      return false;
//    }
// }



// WEBPACK FOOTER //
// ./src/functions/functions.js